import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../../components/header";
import Sidebar from "../../components/sidebar";

const ReceivableLedger = () => {
  const today = new Date().toISOString().split('T')[0];
  const [reportDate, setReportDate] = useState(today);
  const [receivables, setReceivables] = useState([]);
  console.log("received",receivables)

  const handleFetchData = async () => {
    try {
      const res = await axios.post("https://api.trucoo.in/ledger/master-ledger/", {
        date: reportDate
      }, {
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": "erpTrucoo"
        }
      });

      if (res.data.status === 'success') {
        setReceivables(res.data.payments_received || []);
      }
    } catch (err) {
      console.error("Error fetching ledger summary:", err.message);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, [reportDate]);


  const totalAmt = receivables.reduce((sum, receivable) => sum + parseFloat(receivable.amount), 0);

  const getFiscalYearLabel = (date = new Date()) => {
        const year = date.getFullYear();
        const month = date.getMonth(); 
        if (month < 3) {
          return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
          return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
        }
  };

  const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
  };
  return (
    <>
      <Header />
      <Sidebar />
      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <div className="row mt-3">
                  <div className="col-md-3"><h4 className="box-title">Receivable Ledger</h4></div>
                  <div className="col-md-3"></div>
                  <div className="col-md-3"></div>
                  <div className="col-md-3">
                    <input
                      type="date"
                      className="form-control"
                      value={reportDate}
                      onChange={(e) => setReportDate(e.target.value)}
                    />
                  </div>               
                </div>
              </div>
              <div className="box-body">
                <div className="table-responsive">
                  <table className="table-sm table-bordered fs-12" width="100%">
                    <thead className="thead-light">
                      <tr>
                        <th width="3%" className="text-center">S.No</th>
                        <th width="10%" className="text-center">Date</th>
                        <th width="12%" className="text-center">Invoice No</th>
                        <th width="8%" className="text-center">Vehicle No</th>
                        <th className="text-center">Dealer</th>
                        <th width="10%" className="text-center">Total Amount</th>
                        <th width="10%" className="text-center">Payment Mode</th>
                      </tr>
                    </thead>
                    <tbody>
                      {receivables.length > 0 ? (
                        <>
                          {receivables.map((invoice, index) => (
                            <tr key={`invoice-${index}`}>
                              <td>{index + 1}</td>
                              <td>{formatViewDate(invoice.date)}</td>
                              <td>{`TRC/${invoice?.invoiceId}/${getFiscalYearLabel(new Date(invoice?.date))}`}</td>
                              <td>{invoice.vchNo}</td>
                              <td>{invoice.dealerData?.dealer || 'N/A'}</td>
                              <td className="text-end">{Number(invoice.amount).toFixed(2)}</td>
                              <td className="text-end">{invoice.modeOfPayment}</td>
                            </tr>
                          ))}
                          <tr>
                            <th colSpan="5" className="text-right">Total</th>
                            <th className="text-end">{totalAmt.toFixed(2)}</th>
                            <th className="text-end"></th>
                          </tr>
                        </>
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">No invoices with GST found for this date.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ReceivableLedger;